import React from 'react';
import { bucketCsv, downloadCsv, formatBucketLabel, formatCount, formatCurrency, formatPercent, netCents, netSalesCount } from './salesUtils';
import { REFUND_TEXT } from './theme';

const DownloadGlyph = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
  </svg>
);

// Per-bucket breakdown with a client-side CSV export of exactly these rows.
// Sales and Net are net of refunds; Gross and Refunds show what was taken back.
// The table scrolls inside its own card so the page never scrolls sideways.
const BucketTable = ({ series, currency, granularity, filename }) => (
  <div className="sales-card sales-card-flush" data-testid="bucket-table">
    <div className="flex items-center justify-between gap-3 px-5 sm:px-6 py-4">
      <h3 className="sales-heading">By {granularity}</h3>
      <button
        type="button"
        className="sales-btn"
        onClick={() => downloadCsv(filename, bucketCsv(series, { currency, granularity }))}
      >
        <DownloadGlyph />
        Download CSV
      </button>
    </div>
    <div className="overflow-x-auto max-h-96 overscroll-contain">
      <table className="sales-table w-full min-w-[720px] text-sm">
        <thead className="sticky top-0 z-10">
          <tr>
            <th scope="col" className="text-left">Period</th>
            <th scope="col" className="text-right">Sales (net)</th>
            <th scope="col" className="text-right">Gross</th>
            <th scope="col" className="text-right">Refunds</th>
            <th scope="col" className="text-right">Net</th>
            <th scope="col" className="text-right">% of range</th>
            <th scope="col" className="text-right">% of all sales</th>
          </tr>
        </thead>
        <tbody>
          {(series || []).map((b) => {
            const sold = b.sales_count > 0;
            const refunded = (b.refunded_cents || 0) > 0;
            return (
              <tr key={b.bucket_start} className={sold ? 'text-gray-200' : 'text-gray-600'}>
                <td className="text-left">{formatBucketLabel(b.bucket_start, granularity)}</td>
                <td className="text-right">{formatCount(netSalesCount(b))}</td>
                <td className="text-right">{formatCurrency(b.gross_cents, currency)}</td>
                <td className={`text-right ${refunded ? REFUND_TEXT : ''}`}>{formatCurrency(b.refunded_cents, currency)}</td>
                <td className={`text-right ${sold ? 'text-white font-medium' : ''}`}>{formatCurrency(netCents(b), currency)}</td>
                <td className="text-right">
                  <span className="inline-flex items-center justify-end gap-2">
                    <span className="hidden sm:block w-12 sales-track" aria-hidden="true">
                      <span className="sales-fill block" style={{ width: `${Math.min(100, b.pct_of_range_revenue || 0)}%` }} />
                    </span>
                    {formatPercent(b.pct_of_range_revenue)}
                  </span>
                </td>
                <td className="text-right">{formatPercent(b.pct_of_bucket_revenue)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

export default BucketTable;
